import { useBeneficiaryTermStore } from "../stores/beneficiaryTerm.store";

const DEFAULT_SINGULAR = "Beneficiary";
const DEFAULT_PLURAL = "Beneficiaries";

export function useBeneficiaryTerm() {
	const { singular, plural } = useBeneficiaryTermStore();

	return {
		singular: singular || DEFAULT_SINGULAR,
		plural: plural || DEFAULT_PLURAL,
	};
}
